import { Button } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '@/hooks/useLanguage'
import { canShowI18nKey, noLang } from '@/services/i18n'
import { useDispatch, useSelector } from '@/store'
import { changeLanguage } from '@/store/languageSlice'

let lastLang = null

/**
 * 展示i18n key，只在测试和预发布环境展示
 */
export const ShowI18nKeyButton = () => {
  const dispatch = useDispatch()
  const { i18n } = useTranslation()
  const { languageList } = useLanguage()
  const lang = useSelector((s) => s.language.lang)
  if (!canShowI18nKey) return null
  const lanageChange = async () => {
    const langObj = lang === noLang.lang ? lastLang : noLang
    dispatch(changeLanguage(langObj))
    i18n.changeLanguage(langObj.lang)
  }

  if (lang !== noLang.lang) {
    lastLang = languageList.find((l) => l.lang === lang)
  }
  const text = lang === noLang.lang ? '不显示多语言key' : '显示多语言key'
  return (
    <Button onClick={lanageChange} style={{ marginRight: '40px' }} size="small">
      {text}
    </Button>
  )
}
